// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "core.ruffle." + {"662":"73cd4b2216766003e577","966":"bca1371f982df7946ed0"}[chunkId] + ".js";
};